<template>
  <LayoutContainer
    :id="data.cssId"
    class="dbc-c-text-image dbc-c-text-image--medium-left dbc-c-locations"
    :class="`dbc-block-background-${data.backgroundColor}`"
  >
    <LayoutBlock
      class="dbc-c-text-image__text-block dbc-c-locations__block"
      :class="`dbc-block-background-${data.backgroundColorTextBox}`"
      data-aos="fade-left"
      data-aos-delay="300"
    >
      <UtilityHeadline
        v-if="data.headlineH2"
        :class="`dbc-text-color-${data.headlineH2Color}`"
        :text="data.headlineH2"
        :level="2"
        :aos="{ fadeDirection: 'fade-left', delay: 400 }"
        :category="{ text: data.categoryH2, color: data.categoryH2Color }"
      />

      <UtilityText
        v-if="data.text"
        :class="`dbc-text-color-${data.textColor}`"
        :text="data.text"
        :aos="{ fadeDirection: 'fade-left', delay: 500 }"
      />

      <UtilityButton
        v-if="data.button"
        :aos="{ fadeDirection: 'fade-left', delay: 550 }"
        :button="data.button"
      />
    </LayoutBlock>

    <LayoutBlock
      class="dbc-c-text-image__medium-block dbc-c-locations__block"
      data-aos="fade-right"
      data-aos-delay="300"
      data-offset="200"
    >
      <div class="dbc-c-locations__map-container" aria-hidden="true">
        <div class="dbc-c-locations__map">
          <ContentLocationsLocation
            v-for="location in data.locations"
            :key="location.id"
            :location="location"
          />
        </div>
      </div>
    </LayoutBlock>
  </LayoutContainer>
</template>

<script setup lang="ts">
const props = defineProps<{
  content: ContentLocations
}>()
const data = normalizeContentLocations(props.content)
</script>
